// @flow

import $ from 'jquery'

import { selectGrade, selectType } from './actions/buttons'
import { updateCards } from './actions/cards'
import { pushInterest } from './actions/interests'
import './index.css'

export default () => {
  updateCards()

  $('[data-button="select-grade"]').on('click', ({ currentTarget }) => selectGrade($(currentTarget)))
  $('[data-button="select-type"]').on('click', ({ currentTarget }) => selectType($(currentTarget)))
  $('[data-button="open-link"]').on('click', ({ currentTarget }) => pushInterest($(currentTarget)))
}
